import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { HAS_LOGGED_IN_KEY } from '../../utils/storageKeys';

const PrivateRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
        <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
          Verificando autenticación...
        </p>
      </div>
    );
  }

  // ONLY check authentication - NO subscription verification
  if (isAuthenticated) return <Outlet />;
  let conocido = false;
  try { conocido = localStorage.getItem(HAS_LOGGED_IN_KEY) === '1'; } catch { /* sin storage */ }
  return <Navigate to={conocido ? '/signin' : '/signup'} replace />;
};

export default PrivateRoute;
